const experimentRouter = [
  {
    path: '/experiment',
    redirect: '/simulation/experiment',
    name: 'experiment-default',
    component: () => import('../../views/experiment/default.vue'),
    meta: {
      title: '实验首页'
    },
    children: [
      {
        path: '/simulation/experiment',
        name: 'Experiment',
        component: () => import('../../views/experiment/home/index.vue'),
        meta: {
          title: '实验'
        }
      },
      {
        path: '/simulation/describe',
        name: 'experiment-describe',
        component: () => import('../../views/experiment/describe/index.vue'),
        meta: {
          title: '项目描述'
        }
      }
    ]
  }
]
export default experimentRouter
